import { Box, Text } from "@chakra-ui/layout";

const DashboardCard = ({
	title,
	value,
}: {
	title: string;
	value: string | number;
}) => {
	return (
		<Box
			w="100%"
			border="solid 1px"
			borderColor="gray.300"
			borderRadius="xl"
			p="16px"
		>
			<Text lineHeight="21px" fontSize="14px" fontWeight="500" color="gray.600">
				{title}
			</Text>
			<Text lineHeight="48px" fontSize="32px" fontWeight="950">
				{value}
			</Text>
		</Box>
	);
};

export default DashboardCard;
